export default __webpack_public_path__ + "static/media/create-campaigns-7.46dc6601.png";